// import { httpClient } from "@/app/shared/services";

import { apiConstants } from "../../config";
import { apiPost } from "../../../../../shared/services";

const updateUser = async (data, validator) => {
  let url = apiConstants.updateUserUrl;
  return await apiPost(url, { ...data }, validator);
};

export { updateUser };
